import { EnvelopeSimple, ChatCircleDots } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/riq";
import ContactForm from "@/components/ContactForm";

export default function Contact() {
  const { user } = useAuth();
  return (
    <div className="max-w-2xl space-y-6" data-testid="contact-page">
      <div>
        <h1 className="font-head text-3xl font-bold tracking-tight text-riq-primary">Contact us</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Have a question, found a bug, or want to tell us something? Send us a message and we'll reply by email.
        </p>
      </div>

      <div className="grid gap-3 sm:grid-cols-2">
        <Card className="flex items-center gap-3 p-4">
          <div className="grid h-10 w-10 place-items-center rounded-xl bg-riq-sage/60 text-riq-primary"><EnvelopeSimple size={20} weight="duotone" /></div>
          <div className="min-w-0">
            <div className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">Email us</div>
            <a href="mailto:info@sliply.co.za" className="text-sm font-semibold text-riq-primary hover:underline">info@sliply.co.za</a>
          </div>
        </Card>
        <Card className="flex items-center gap-3 p-4">
          <div className="grid h-10 w-10 place-items-center rounded-xl bg-riq-gold/20 text-riq-primary"><ChatCircleDots size={20} weight="duotone" /></div>
          <div className="min-w-0">
            <div className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">Response time</div>
            <div className="text-sm font-semibold text-riq-primary">Usually within 1 business day</div>
          </div>
        </Card>
      </div>

      <Card>
        <ContactForm defaultName={user?.name || ""} defaultEmail={user?.email || ""} />
      </Card>
    </div>
  );
}
